import React from "react";

const AppML_History = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML History</h1>
      <p>This is the AppML History page content.</p>
    </div>
  );
};

export default AppML_History;
